import { chakra } from '@chakra-ui/react';
import { t } from 'i18next';
import { useAuth } from '~auth/useAuth';
import {
  canViewReceivedAccessRequests,
  canViewSentAccessRequests,
  isInternalOrganization,
} from '~components/organization/AccessRequests/accessRequestUtils';
import { ReceivedAccessRequests } from '~components/organization/AccessRequests/ReceivedAccessRequests';
import { SentAccessRequests } from '~components/organization/AccessRequests/SentAccessRequests';
import { VerticalTabContent } from '~components/ui/VerticalTabs';

export function OrganizationAccessRequestsIndexPage() {
  const { verifyUserPermissions, organization } = useAuth();
  const isInternal = isInternalOrganization(organization?.id);

  return (
    <VerticalTabContent title={t('accessRequests')}>
      <chakra.p fontSize="md" color="gray.500" marginBottom="10">
        {t('accessRequestsDescription')}
      </chakra.p>
      {canViewSentAccessRequests(verifyUserPermissions, isInternal) && <SentAccessRequests />}
      {canViewReceivedAccessRequests(verifyUserPermissions, isInternal) && (
        <ReceivedAccessRequests />
      )}
    </VerticalTabContent>
  );
}
